import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useRef } from "react";
import "../styles/AboutUs.css";
import "animate.css"; // You are already importing this
import AboutUsSection from "./AboutUsSection";
import JourneyTimeline from "./JourneyTimeline";

function AboutUs() {
  // Ref for the journey section
  const journeySectionRef = useRef(null);

  // Function to handle the smooth scroll
  const handleScrollToJourney = () => {
    journeySectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
       <Helmet>
        <title>
          About Us | Industrial Catering Experts
        </title> 
        <meta
          name="description"
          content="Get to know Laxmi Hospitality Services—India's industrial catering pioneers since 2009, our journey serving 14,550+ fresh meals daily across five states."
        />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link
          rel="canonical"
          href="https://laxmihospitalityservices.in/aboutus"
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://laxmihospitalityservices.in/aboutus"
        />
        <meta
          property="og:title"
          content="About Laxmi Hospitality Services – Industrial Catering Experts"
        />
        <meta
          property="og:description"
          content="Since 2009 we’ve redefined industrial catering, delivering 14,550+ nutritious meals daily to India’s leading manufacturers."
        />
        <meta property="og:site_name" content="Laxmi Hospitality Services" />
        <meta property="og:locale" content="en_IN" />
        <meta
          property="og:image"
          content="https://laxmihospitalityservices.in/images/About-us-banner.jpg"
        />

        {/* -------- ABOUT PAGE STRUCTURED DATA -------- */}
        <script type="application/ld+json">{`
      {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        "@id": "https://laxmihospitalityservices.in/aboutus",
        "name": "About Laxmi Hospitality Services",
        "description": "Industrial catering specialists since 2009, serving 14,550+ fresh meals daily across five Indian states.",
        "url": "https://laxmihospitalityservices.in/aboutus",
        "about": { "@id": "https://laxmihospitalityservices.in/#organization" },
        "publisher": { "@id": "https://laxmihospitalityservices.in/#organization" },
         "sameAs": [
        "https://www.linkedin.com/company/laxmi-hospitality-services/",
        "https://www.instagram.com/laxmi_hospitality_services/"
      ],
        "inLanguage": "en-IN"
      }
      `}
      </script>

        {/* -------- SITE-WIDE BREADCRUMB-------- */}
        <script type="application/ld+json">{`
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "@id": "https://laxmihospitalityservices.in/#breadcrumb",
            "name": "Website Breadcrumb",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "Home",     "item": "https://laxmihospitalityservices.in/" },
              { "@type": "ListItem", "position": 2, "name": "About Us", "item": "https://laxmihospitalityservices.in/aboutus" }
            ]
          }
      `}
     </script>
      </Helmet>

      <div className="about-page">
        <div className="about-hero-section">
          <img
            src="/images/About-us-banner.jpg"
            alt="Welcome to Laxmi Hospitality Services"
            className="about-hero-image"
            title="Hero image for About Us"
          />
          <div className="about-hero-overlay">
            <h1 className="about-hero-title">About Us</h1>
            <p className="about-hero-breadcrumb">
              <Link to="/" className="about-hero-breadcrumb-link">
                Home
              </Link>{" "}
              / About Us
            </p>

            {/* The new button with an animation */}
            <button
              onClick={handleScrollToJourney}
              className="explore-journey-btn"
            >
              Explore Our Journey
            </button>
          </div>
        </div>

        <AboutUsSection />

          <div ref={journeySectionRef} className="journey-section-wrapper"> 
          <JourneyTimeline />
        </div>
      </div>
    </>
  );
}

export default AboutUs;